const tabs = Array.from(document.querySelectorAll(".theme-tab"));
const bands = Array.from(document.querySelectorAll(".theme-band"));

function selectTheme(theme) {
  const nextTheme = theme || "all";

  tabs.forEach((tab) => {
    const isActive = tab.dataset.filter === nextTheme;
    tab.classList.toggle("is-active", isActive);
    tab.setAttribute("aria-pressed", String(isActive));
  });

  bands.forEach((band) => {
    const shouldShow = nextTheme === "all" || band.dataset.theme === nextTheme;
    band.classList.toggle("is-hidden", !shouldShow);
  });

  if (window.location.hash !== `#${nextTheme}`) {
    history.replaceState(null, "", `#${nextTheme}`);
  }
}

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    selectTheme(tab.dataset.filter);
    document.getElementById("manual-content")?.scrollIntoView({ block: "start" });
  });
});

const initialTheme = window.location.hash.replace("#", "");
if (tabs.some((tab) => tab.dataset.filter === initialTheme)) {
  selectTheme(initialTheme);
}
